import _ from "underscore"
import {ReportGroupingLevel} from "../constants"
import {RowType} from "./RowType"

export default class BaseTableDataConverter {
    constructor(reportData, reportParams) {
        this.reportData = reportData;
        this.reportParams = reportParams;
    }

    convert() {
        var groupingLevels = this.getGroupingLevels(this.reportParams);
        this.types = this.getTypes(groupingLevels);
        this.groupingTypes = this.getGroupingLevelsCollapsed(groupingLevels);

        var rows = [];
        rows.push(this._createHeader());
        rows.push(this._createDataRow(-1, RowType.TOTALS, ReportGroupingLevel.NONE, this.reportData));

        this.addDataRecursive(this.reportData, rows, 0);
        return rows;
    }

    addDataRecursive(item, rows, level) {
        if (item.items.length == 0) {
            return;
        }

        _.each(item["items"], function(item) {
            var groupingType = this.groupingTypes[level];
            var type = this.types[level];
            rows.push(this._createDataRow(level, type, groupingType, item));
            this.addDataRecursive(item, rows, level + 1);
        }, this);
    }

    getTypes(groupingLevels) {
        var types = {};
        var level = 0;
        for (var i = 0; i < groupingLevels.length; ++i) {
            if (groupingLevels[i] !== ReportGroupingLevel.NONE) {
                types[level] = i + RowType.FIRST_LEVEL;
                level++;
            }
        }
        return types;
    }

    getGroupingLevelsCollapsed(groupingLevels) {
        return _.filter(groupingLevels, function(level) {return level !== ReportGroupingLevel.NONE;})
    }

    _createHeader(reportData, reportParams) {
        // abstract
    }

    _createDataRow(level, type, groupingLevel, leavesReportItem) {
        // abstract
    }

    getGroupingLevels(params) {
        var array = [];
        array.push(params.firstGroupingLevel);
        array.push(params.secondGroupingLevel);
        return array;
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/table/BaseTableDataConverter.js